import { render, staticRenderFns } from "./pointsRule.vue?vue&type=template&id=b1654f0e&scoped=true"
import script from "./pointsRule.vue?vue&type=script&lang=js"
export * from "./pointsRule.vue?vue&type=script&lang=js"
import style0 from "./pointsRule.vue?vue&type=style&index=0&id=b1654f0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1654f0e",
  null
  
)

export default component.exports